<template>
  <!-- header -->
  <div>
    <el-top-nav-menu-4
      companyTitle="开发者注册"
      :dashboard="shopPage"
      :showInput="showInput"
      :Menu4Href="Menu4Href"
      ref="topNavMenu"
      :logo="LOGO"
      width="1180px"
      padding="0"
      :showHelp="false"
    >
      <div class="ldg" @click="goser">
        <span class="dpng">我已注册，查看审批进展</span>
        <div class="los">
          <img :src="leftgg">
        </div>
      </div>
    </el-top-nav-menu-4>
    <!-- openStep -->
    <div style="background-color: white; width: 1180px;margin: 0 auto;">
      <div class="openStep">

        <div class="one">
          <div class="circle check_circle">
            <div class="circle1">1</div>
          </div>
          <span :class="check_page >= 0 ? ' check_stepTxt' : 'stepTxt'"
          >快速注册</span
          >
        </div>
        <span class="circleSmall circleSmall1"></span>
        <span class="circleSmall circleSmall2"></span>
        <span class="circleSmall circleSmall3"></span>
        <div class="two">
          <div :class="check_page >= 1 ? 'circle check_circle' : 'circle'">
            <div class="circle1">2</div>
          </div>
          <span :class="check_page >= 1 ? ' check_stepTxt' : 'stepTxt'"
          >人工审核</span
          >
        </div>
      </div>

    </div>
    <div v-if="check_page == 0">
      <register
        @next="next"

      ></register>
    </div>

    <div v-if="check_page == 1">
      <approval
        @nextPerfectInfo="nextPerfectInfo"
        @PreviousInfo="previousInfo"
      ></approval>
    </div>

  </div>
</template>

<script>

import register from './register';
import approval from './approval';

import LOGO from '@/assets/images/logoS.png';
import { getCompany, getUserInfo } from '@/api/register';

export default {
  data() {
    return {
      leftgg: require('@/assets/images/llop.png'),
      shopPage: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      Menu4Href: true,
      LOGO: LOGO,
      showInput: false,

      check_page: 0,

      flag: false

    };
  },
  components: {
    register,
    approval

  },
  computed: {
    dialogVisible2() {
      return this.$store.state.app.isShowDialogTimeout;
    }
  },
  mounted() {
    document.title = '开发者注册'
  },
  methods: {
    goser() {
      this.$router.push({ path: '/queryQrogress' });
    },
    next() {
      this.check_page++;
    },
    nextPerfect({ name }) {
      this.check_page++;
    },
    toFlag() {
      this.flag = false;
    },
    nextPerfectInfo() {
      this.check_page++;
    },
    previousInfo() {
      this.check_page--;
      this.flag = true;
    },
    previous() {
      this.check_page--;
    }
  }
};
</script>

<style lang="scss" scoped>
  .ldg {

    float: right;
    margin-top: 30px;
    cursor: pointer;
  }

  .dpng {
    font-size: 16px;
    color: #FFFFFF;
    line-height: 18px;
    float: left;
    margin-right: 10px;
  }

  .los img {
    width: 100%;
  }

  .los {
    width: 18px;
    height: 18px;
    float: left;
  }

  /deep/ .el-top-nav-menu4 .sub-menu-wrapper-wrapper .sub-menu-wrapper .logo-container img {
    display: inline-block;
    vertical-align: middle;
    // width: 180px;

    border: none;

  }

  > html,
  body {
    font-family: Arial;
    background-color: #f5f5f9;
    padding: 0px;
    margin: 0px;
    -webkit-font-smoothing: antialiased; /*让字体更润滑*/
    -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
    -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
    height: 100%;
  }

  ul,
  li {
    margin: 0px;
    padding: 0px;
    list-style: none;
  }

  input,
  button {
    border: 0 none;
    border-radius: 0px;
    outline: none;
  }

  /* header */
  .header {
    min-width: 1260px;
    height: 80px;
    background: rgba(255, 20, 47, 1);
    position: relative;
  }

  .headerLogo {
    width: 115px;
    height: 40px;
    position: absolute;
    top: 20px;
    left: 50px;
  }

  .headerLine {
    display: block;
    width: 1px;
    height: 16px;
    background: rgba(255, 255, 255, 1);
    border-radius: 1px;
    position: absolute;
    top: 32px;
    left: 171px;
  }

  .header .headerTxt {
    width: 128px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
    position: absolute;
    top: 29px;
    left: 178px;
  }

  /* openStep */
  .openStep {
    width: 680px;
    height: 150px;
    background: rgba(255, 255, 255, 1);
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 210px;
  }

  .openStep .circle {
    width: 51px;
    height: 51px;
    border-radius: 50%;
    background: #b2dbfa;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    /* opacity: 0.3; */
  }

  .openStep .circle1 {
    width: 43px;
    height: 43px;
    border-radius: 50%;
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(
        #adcef8 0%,
        #9bdefd 100%
    );
    line-height: 37px;
    text-align: center;
    line-height: 43px;
  }

  .openStep .check_circle .circle1 {
    background: linear-gradient(
        #02c7f0 0%,
        #0283de 100%
    );
  }

  .openStep .circleSmall {
    display: block;
    width: 9px;
    height: 9px;
    border-radius: 4px;
    background: rgba(221, 221, 221, 1);
    margin: 20px -8px;
    margin-top: -12px;
  }

  .openStep .stepTxt {
    display: block;
    width: 53px;
    height: 18px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: rgba(153, 153, 153, 1);
    line-height: 18px;
    text-align: center;
  }

  .check_stepTxt {
    display: block;
    width: 53px;
    height: 18px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
    color: #0089EF;
  }

  .five span {
    margin-left: 14px;
  }

  /* content */
  .content {
    width: 1180px;
    min-height: 325px;
    max-height: calc(100vh - 290px);
    background: rgba(255, 255, 255, 1);
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    font-size: 50px;
    text-align: center;
    line-height: calc(100vh - 290px);
    position: relative;
  }

  .right-btn {
    position: absolute;
    bottom: 20px;
    left: 340px;
    margin: 0 auto;
    width: 500px;
    height: 40px;
    background: rgba(255, 20, 47, 1);
    border-radius: 4px;
    span {
      span {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
      }
    }
  }

  .right-btn:hover {
    background: rgba(255, 20, 47, 1);
  }

  .fid {
    width: 600px;
    display: flex;
    align-items: center;
  }
</style>
